import { GET, } from "../../helper/xbi4RestFunctions";
export const getOrgProjectRoles = async (org_id: any) => {
  const path = `/orgs/${org_id}/projects/roles`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
